import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";

export interface ResetPasswordResponseInterface {
  data: {
  };
}
export interface ResetPasswordArgument {
  email: string;
}
export interface ResetPasswordSetPasswordArgument {
  token: string,
  password: string,
  password_confirmation: string
}

export function postResetPassword(resetPasswordData: ResetPasswordArgument): Promise<AxiosResponse<ResetPasswordResponseInterface, any>> {
  return axiosInstance.post("user/reset_password", resetPasswordData);
}

export function patchResetPassword(data: ResetPasswordSetPasswordArgument): Promise<AxiosResponse<ResetPasswordResponseInterface, any>> {
  return axiosInstance.patch("user/reset_password", data);
}
